import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import DnsIcon from "@mui/icons-material/Dns";
import { connect } from "react-redux";
import AddFriendDialog from "../FriendsSidebar/AddFriendDialog";
import PendingInvitationsList from "../FriendsSidebar/PendingInvitationsList/PendingInvitationsList";
import ServerInvitationsList from "../FriendsSidebar/ServerInvitationsList";
import FriendsList from "../FriendsSidebar/FriendsList/FriendsList";
import { setSelectedServer } from "../../store/actions/roomActions";
import { chatTypes, setChosenChatDetails } from "../../store/actions/chatActions";

const tabs = [
  { id: "friends", label: "Друзья", icon: PeopleAltIcon },
  { id: "invites", label: "Приглашения", icon: MarkEmailUnreadIcon },
  { id: "servers", label: "Серверы", icon: DnsIcon },
];

const TabButton = ({ active, label, Icon, onClick }) => (
  <Button
    startIcon={<Icon sx={{ fontSize: 18 }} />}
    onClick={onClick}
    sx={{
      height: "32px",
      px: "12px",
      color: active ? "#fff" : "#b5bac1",
      bgcolor: active ? "#393c43" : "transparent",
      textTransform: "none",
      fontWeight: 800,
      "&:hover": { bgcolor: "#393c43", color: "#fff" },
    }}
  >
    {label}
  </Button>
);

const HomeView = ({ servers, setSelectedServer, setChosenChatDetails }) => {
  const [tab, setTab] = useState("friends");
  const [isAddFriendOpen, setIsAddFriendOpen] = useState(false);

  const openServer = (server) => {
    setSelectedServer(server);
    const textChannel = server.channels.find((channel) => channel.type === "TEXT");
    if (textChannel) {
      setChosenChatDetails(
        {
          id: textChannel.id,
          name: `# ${textChannel.name}`,
          serverId: server.id,
          channelType: "TEXT",
        },
        chatTypes.CHANNEL
      );
    }
  };

  return (
    <Box sx={{ width: "100%", height: "100%", color: "#f2f3f5", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          height: "48px",
          borderBottom: "1px solid #111214",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          px: "18px",
          boxSizing: "border-box",
          flexShrink: 0,
        }}
      >
        {tabs.map((item) => (
          <TabButton
            key={item.id}
            active={tab === item.id}
            label={item.label}
            Icon={item.icon}
            onClick={() => setTab(item.id)}
          />
        ))}
        <Button
          onClick={() => setIsAddFriendOpen(true)}
          sx={{
            ml: "8px",
            height: "32px",
            bgcolor: "#f97316",
            color: "#fff",
            textTransform: "none",
            fontWeight: 800,
            "&:hover": { bgcolor: "#ea580c" },
          }}
        >
          Добавить в друзья
        </Button>
      </Box>

      <Box sx={{ p: "24px 28px", overflowY: "auto", flexGrow: 1 }}>
        {tab === "friends" && (
          <>
            <Typography sx={{ fontSize: "22px", fontWeight: 900, mb: 2 }}>Друзья</Typography>
            <Box sx={{ maxWidth: "420px" }}>
              <FriendsList />
            </Box>
          </>
        )}
        {tab === "invites" && (
          <>
            <Typography sx={{ fontSize: "22px", fontWeight: 900, mb: 2 }}>Приглашения</Typography>
            <Box sx={{ maxWidth: "560px" }}>
              <PendingInvitationsList />
            </Box>
          </>
        )}
        {tab === "servers" && (
          <>
            <Typography sx={{ fontSize: "22px", fontWeight: 900, mb: 2 }}>Серверы</Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "560px", mb: 3 }}>
              {servers.map((server) => (
                <Button
                  key={server.id}
                  onClick={() => openServer(server)}
                  sx={{
                    justifyContent: "flex-start",
                    height: "44px",
                    color: "#f2f3f5",
                    bgcolor: "#24262b",
                    textTransform: "none",
                    fontWeight: 800,
                    "&:hover": { bgcolor: "#393c43" },
                  }}
                >
                  {server.name}
                </Button>
              ))}
            </Box>
            <Box sx={{ maxWidth: "560px" }}>
              <ServerInvitationsList />
            </Box>
          </>
        )}
      </Box>
      <AddFriendDialog isDialogOpen={isAddFriendOpen} closeDialogHandler={() => setIsAddFriendOpen(false)} />
    </Box>
  );
};

const mapStoreStateToProps = ({ room }) => ({
  servers: room.servers,
});

export default connect(mapStoreStateToProps, {
  setSelectedServer,
  setChosenChatDetails,
})(HomeView);
